import {Button} from '@dabafinance/react-components';
import styles from './affiliates.module.scss';
import AffiliatesTable from './page/AffiliatesTable/AffiliatesTable';
import {useEffect, useState} from 'react';
import AffiliateReservations from './page/AffiliateReservations/AffiliateReservations';
import AffiliateConfigurationDashboard from './page/AffiliateConfiguration';
import {useLocation, useNavigate} from 'react-router-dom';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

const AFFILIATE_SUBTABS = [
  {key: 'affiliates', value: 'AFFILIATES', label: 'AFFILIATES'},
  {key: 'reservations', value: 'RESERVATIONS', label: 'RESERVATIONS'},
  {key: 'configuration', value: 'CONFIGURATION', label: 'CONFIGURATION'},
];

const Affiliates = () => {
  const history = useNavigate();
  const location = useLocation();
  const [modalContent, setModalContent] = useState({});

  const [activeTab, setActiveTab] = useState('AFFILIATES');
  const {visibleSubTabs, visibleKeys, firstVisible} = useVisibleSubTabs(
    NavTabsEnum.Affiliates,
    AFFILIATE_SUBTABS,
  );

  // Effect to set the active tab based on the search param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    const granted = AFFILIATE_SUBTABS.find(
      sub => sub.value === tab && visibleKeys.includes(sub.key),
    );
    if (granted) {
      setActiveTab(granted.value);
    } else if (firstVisible) {
      setActiveTab(firstVisible.value);
    }
  }, [location.search, visibleKeys, firstVisible]);

  const handleTabClick = tab => {
    setActiveTab(tab);
    history(`?tab=${tab}`);
  };

  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <h1>Affiliates</h1>
        {activeTab === 'AFFILIATES' && (
          <Button
            label="Create Affiliate"
            onClick={() => setModalContent({isOpen: true, type: 'CREATE'})}
          />
        )}
      </div>
      <div className={styles['details-toggler']}>
        {visibleSubTabs.map(tab => (
          <span
            key={tab.key}
            className={activeTab === tab.value ? styles['active-toggle'] : ''}
            onClick={() => handleTabClick(tab.value)}>
            {tab.label}
          </span>
        ))}
      </div>
      <div>
        {activeTab === 'AFFILIATES' && (
          <AffiliatesTable
            modalContent={modalContent}
            setModalContent={setModalContent}
          />
        )}
        {activeTab === 'RESERVATIONS' && (
          <AffiliateReservations isAffiliate={true} />
        )}
        {activeTab === 'CONFIGURATION' && <AffiliateConfigurationDashboard />}
      </div>
    </div>
  );
};

export default Affiliates;
